import React from "react";
import { useLocation } from "react-router-dom";
import MobileCampaignList from "./MobileCampaignList";
import MobileCampaignPage from "./MobileCampaignPage";

const getViewMode = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return "list";
  return "campaign";
};

const MobileRecruitmentApp = () => {
  const { pathname } = useLocation();
  const viewMode = getViewMode(pathname);

  if (viewMode === "list") {
    return <MobileCampaignList />;
  }

  return <MobileCampaignPage />;
};

export default MobileRecruitmentApp;
